// import IconButton from '../components/IconButton';
// import ModalDialog from '../components/ModalDialog';

import IconButton from 'components/IconButton';
import React, { useState } from 'react';

import AccountDetailModal from './AccountDetailModal';
import useActivateDeactivateAccount from './hooks';
import ReConnectAccountModal from './ReConnectAccountModal';
import history from '../../../history';
import { getOAuthUrl, BASE_URL } from '../helper';

const Actions = ({ rowData }) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [reConnectModalOpen, setReConnectModalOpen] = useState(false);

  const { loading: accountActionLoading, handleActivateDeactivateAccount } =
    useActivateDeactivateAccount();

  const handleConnect = () => {
    //connect action here, using rowData to access row-specific data
    const oauthUrl = getOAuthUrl(rowData.host_type, 'revive', rowData.id);
    if (oauthUrl) window.location.href = oauthUrl;
  };

  const rowId = rowData['id'];
  const isInActive =
    !rowData.is_active && rowData.token_info?.access_token_failed_attempts < 10;
  const isActive = !isInActive;
  const isDisconnected =
    !rowData.is_active && rowData.token_info.access_token_failed_attempts >= 10;
  return (
    <div className="text-nowrap">
      {/* <IconButton id="scansLink" size='sm'
          onClick={() => { }}
          iconElement={manualScanSpinner}
        /> */}
      {isDisconnected ? (
        <IconButton
          id={`scanLink${rowId}`}
          iconClass="fa fa-refresh"
          size="sm"
          tooltip={
            <>
              Click to re-connect account
              <br />
              <br /> Account got disconnected somehow and need to be
              reconnected.
            </>
          }
          onClick={() => setReConnectModalOpen(!reConnectModalOpen)}
        />
      ) : (
        <IconButton
          id={`toggle_${rowId}`}
          disabled={accountActionLoading}
          iconClass={`fa-solid ${isActive ? 'fa-toggle-on' : 'fa-toggle-off'}`}
          size="sm"
          tooltip={
            isInActive
              ? 'Activate scanning on all repositories associated with this account'
              : 'Deactivate scanning on all repositories associated with this account'
          }
          onClick={() =>
            handleActivateDeactivateAccount(rowId, !isActive, rowData)
          }
        />
      )}

      <IconButton
        id={`addRepoLink_${rowId}`}
        iconClass="fa fa-sitemap"
        size="sm"
        tooltip="Add repositories for this account"
        disabled={!isActive || accountActionLoading || isDisconnected}
        onClick={() => {
          history.push(
            `/${BASE_URL}/sast/?account=${rowData['id']}&t=add_repos`,
          );
        }}
      />
      <IconButton
        id={`detailsLink_${rowId}`}
        iconClass="fa fa-eye"
        size="sm"
        tooltip="View account details"
        onClick={() => setModalOpen(!modalOpen)}
      />
      {modalOpen && (
        <AccountDetailModal
          accountId={rowId}
          isOpen={modalOpen}
          isActive={isActive}
          isLoading={accountActionLoading}
          toggle={() => setModalOpen(!modalOpen)}
          accountRowData={rowData}
          handleActivateDeactivateAccount={handleActivateDeactivateAccount}
        />
      )}
      {reConnectModalOpen && (
        <ReConnectAccountModal
          hostType={rowData.host_type}
          account={rowData}
          onConnect={handleConnect}
          onClose={() => setReConnectModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Actions;
